module.exports = __webpack_public_path__ + "img/special.8f886652.png";